import { createActions, createState, createReducer } from 'reduxsauce-crud'

/* ------------- Types and Action Creators ------------- */

export const CountriesRedux = createActions({}, {
  prefix: 'COUNTRIES_',
  defaultActions: {
    get: true,
  },
})

const { Types, Creators } = CountriesRedux
export const CountriesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = createState({}, {
  get: true,
})

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {}, {
  defaultActions: {
    get: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/CountriesRedux.js